<template>
  <v-content>
    <template v-if="info">
      <v-row no-gutters><h1 class="text-center w-100">{{info.name}}</h1></v-row>
      <v-row>
        <v-col
          :cols=" stackImage ? '12' : '6'"
          :order="flip && !stackImage ? '3' : '1'"
          class="h-100"
        >
          <v-layout align-center>
            <v-img
              :src="info.image"
              aspect-ratio="1"
              width="320px"
              max-width="320px"
              class="mx-auto"
            ></v-img>
          </v-layout>

        </v-col>
        <v-col order="2">
          <div class="h-100">
            <v-layout align-center wrap
              class="chat-description-text title font-weight-light"
              v-html="info.description">
            </v-layout>

            <v-row no-gutters class="chat-button-group w-100" >
              <v-btn
                v-if="showRulesButton"
                tile
                color="secondary"
                :class="showJoinButton ? 'mr-4' : 'mr-auto'"
                class="ml-auto mr-4"
                @click="$emit('rules')"
              >
                Chat Rules
              </v-btn>
              <v-btn
                v-if="showJoinButton"
                tile
                :class="showRulesButton ? '' : 'ml-auto'"
                class="mr-auto"
                color="primary"
                @click="$emit('join')"
              >Join</v-btn>
            </v-row>
          </div>

        </v-col>
      </v-row>
    </template>
  </v-content>
</template>

<script>
  export default {
    name: 'CharCard',
    props: {
        flip: {
            type: Boolean,
            required: false,
            default: false
        },
        chat: {
            type: Object,
            required: true
        },
        stack:{
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch:{
      chat: {
          deep: true,
          handler(newValue) {
              this.info = newValue;
          }
      },
      stack(newValue){
        this.stackImage = newValue;
      }
    },
    computed: {
      showRulesButton() {
          return this.info.rules && this.info.rules.type;
      },
      showJoinButton() {
          return this.info.join && this.info.join.type;
      }
    },
    data() {
        return {
            info: this.chat,
            stackImage: this.stack
        }
    }
  }
</script>
<style>
 .chat-description-text {
   height: calc(100% - 36px);
   max-height: calc(100% - 36px);;
   overflow: hidden;
 }
</style>
